(function () {
    "use strict";

    angular.module("app").factory("infiniteScrollDataSourceFactory", InfiniteScrollDataSourceFactory);

    InfiniteScrollDataSourceFactory.$inject = ["notificationService", "infiniteScrollService"];
    function InfiniteScrollDataSourceFactory(notificationService, infiniteScrollService) {

        return {
            Create: create,
            CreateChild: createChild
        };

        function create(api, setLoadingStatus, processData) {
            const settings = new DataSourceSettings(api, setLoadingStatus, processData, true);
            if (!settings.IsValid())
                return undefined;

            return new DataSource(settings);
        }

        function createChild(api, setLoadingStatus, processData) {
            const settings = new DataSourceSettings(api, setLoadingStatus, processData, false);
            if (!settings.IsValid())
                return undefined;

            return new DataSource(settings);
        }

        function DataSourceSettings(api, setLoadingStatus, processData, useUrl) {
            this.Api = api;
            this.SetLoadingStatus = setLoadingStatus;
            this.UseUrl = useUrl || false;
            this.ProcessData = angular.isFunction(processData) ? processData : angular.noop;

            this.IsValid = function () {
                const isValid = angular.isFunction(this.Api) && angular.isFunction(this.SetLoadingStatus);
                if (!isValid)
                    console.error("InfiniteScrollDataSourceFactory: Missing callbacks");
                return isValid;
            };
        }

        function DataSource(settings) {
            const context = {
                loader: settings.Api,
                setLoadingStatus: settings.SetLoadingStatus,
                processData: settings.ProcessData,
                useUrl: settings.UseUrl,

                Filter: {},
                PageAndSort: { PageNumber: 1, SortBy: [] },

                isLoadingRequests: false,
                TotalPages: 1,

                Items: {},
                HasExecuted: false,
            };

            initializeFilter();

            //#region "Interface"

            this.ResetSearch = reset;
            this.GetNext = loadNext;
            this.OnSorted = onSorted;
            this.RemoveItem = removeItem;

            this.GetFilter = () => context.Filter;
            this.GetPageAndSort = () => context.PageAndSort;
            this.Items = () => context.Items ? context.Items.DtoList : [];
            this.IsEmpty = () => !isInitialized() || context.Items.DtoList.length === 0;
            this.IsComplete = () => context.Items && (context.Items.TotalItems === 0 || context.Items.TotalPages === context.PageAndSort.PageNumber);
            this.ItemCount = () => isInitialized() ? context.Items.DtoList.length : 0;
            this.TotalCount = () => context.Items ? context.Items.ActualTotalItems || context.Items.TotalItems : 0;
            this.Ready = () => context.HasExecuted;
            this.isLoading = () => context.isLoadingRequests;

            //#endregion

            //#region "Implementation"

            function loadNext() {
                if (context.PageAndSort.PageNumber >= context.TotalPages)
                    return;
                if (context.isLoadingRequests) return;
                setIsLoading(true);

                context.PageAndSort.PageNumber += 1;
                load();
            }

            function reset() {
                if (context.isLoadingRequests) {
                    context.ShouldReset = true;
                    return;
                }
                setIsLoading(true);
                context.PageAndSort.PageNumber = 1;
                context.Items = {};
                load();
                infiniteScrollService.ScrollToTop();
            }

            function load() {
                if (context.useUrl)
                    infiniteScrollService.UpdateUrl(context.Filter, context.PageAndSort);

                setIsLoading(true);
                context.loader(
                    { Filter: context.Filter, PageAndSort: context.PageAndSort },
                    processResults,
                    (err) => {
                        DoShowError(notificationService, err);
                        context.Error = true;
                    },
                    () => {
                        context.HasExecuted = true;
                        setIsLoading(false);

                        if (context.ShouldReset) {
                            context.ShouldReset = false;
                            reset();
                        }
                    }
                );
            }

            function removeItem(item) {
                if (!isInitialized())
                    return;

                const i = context.Items.DtoList.indexOf(item);
                if (i > -1) {
                    context.Items.DtoList.splice(i, 1);
                    context.Items.TotalItems--;
                }
            }

            function processResults(result) {
                context.Error = false;
                context.TotalPages = result.data.TotalPages;

                context.processData(result.data.DtoList);

                if (context.PageAndSort.PageNumber == 1)
                    context.Items = result.data;
                else {
                    for (const item of result.data.DtoList)
                        context.Items.DtoList.push(item);
                }
            }

            function initializeFilter() {
                context.Filter = {};
                context.PageAndSort = { SortBy: [] };
                if (context.useUrl) {
                    const filter = infiniteScrollService.ParseFilter();
                    context.Filter = filter.Filter;
                    context.PageAndSort.SortBy = filter.SortBy;
                }                
            }

            function setIsLoading(loading) {
                context.isLoadingRequests = loading;
                context.setLoadingStatus(loading);
            }

            function onSorted(key, isReverse) {
                context.PageAndSort.SortBy = [{ Name: key, IsReverse: isReverse }];
                this.ResetSearch();
            }

            function isInitialized() {
                return context.Items?.DtoList;
            }

            //#endregion
        }
    }
})();
